import { VideoProject } from "@/services/bedrock";
import {
  VIDEO_PROJECT_STATUS_COLUMNS,
  VideoProjectStatusColumnDef,
  VideoProjectStatusColumnId,
  getRepresentativeStatusForColumn,
  getStatusColumnId,
  visibleStatusColumns,
} from "@/components/VideoProjectStatusPicker/columns";

export type KanbanColumnId = VideoProjectStatusColumnId;
export type KanbanColumnDef = VideoProjectStatusColumnDef;

export const KANBAN_COLUMNS: KanbanColumnDef[] = VIDEO_PROJECT_STATUS_COLUMNS;
export const getKanbanColumnId = getStatusColumnId;
export { getRepresentativeStatusForColumn };
export const visibleKanbanColumns = visibleStatusColumns;

export function isKanbanCardDraggable(status: VideoProject.Status): boolean {
  return status !== VideoProject.Status.POSTED && status !== VideoProject.Status.POST_FAILED;
}

function hasQueueRole(project: VideoProject, userId: number, role: VideoProject.QueueAssignment["role"]): boolean {
  return (
    project.queueAssignments?.some(assignment => assignment.staffUserId === userId && assignment.role === role) ?? false
  );
}

export function showKanbanPriorityAccent(project: VideoProject, currentUserId?: number | null): boolean {
  if (currentUserId == null) return false;

  if (project.status.endsWith("EDITING")) {
    return (
      project.editorUserId === currentUserId ||
      (project.editorUserId == null && hasQueueRole(project, currentUserId, "EDITOR"))
    );
  }

  if (project.status.endsWith("QA_REVIEW")) {
    return (
      project.qaUserId === currentUserId || (project.qaUserId == null && hasQueueRole(project, currentUserId, "QA"))
    );
  }

  return false;
}
